import React from "react";
import { Card, CardHeader, Col, Row, Spinner } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchTopMerchants } from "store/actions/statsActions";
import BarChart from "components/shared/Charts/BarChart";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";

const TopMerchantsCard = ({ type, dates, merchant }) => {
  const { startDate, endDate } = dates;
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const payload = {
    type,
    dateRange: { startDate, endDate },
    id: user?.type === "admin" && merchant?.id ? merchant?.id : ""
  };

  const {
    data: latestTopMerchants = [],
    isFetching,
    isError,
    error
  } = useQuery({
    queryKey: ["topMerchants", payload],
    queryFn: () => dispatch(fetchTopMerchants(payload)),
    staleTime: 60 * 60 * 1000,
    cacheTime: 70 * 60 * 1000,
    keepPreviousData: true
  });

  if (isError) {
    toast.error(error?.message || "Failed to fetch top merchants.");
  }

  const topMerchantOptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false
      }
    },
    xaxis: {
      categories: latestTopMerchants.map(
        (val) => val?.name?.split(" ")[0] || ""
      ),
      labels: {
        style: {
          fontFamily: "Poppins, sans-serif"
        }
      }
    },
    plotOptions: {
      chart: {
        toolbar: {
          show: false
        }
      },
      bar: {
        horizontal: false,
        endingShape: "flat",
        columnWidth: "17%",
        dataLabels: {
          position: "top",
          offsetY: -10,
          style: {
            fontSize: "12px"
          }
        }
      }
    },
    dataLabels: {
      enabled: false,
      formatter: function (val) {
        return val + " ORDERS";
      },
      offsetY: -20,
      style: {
        fontSize: "10px"
      }
    },
    toolbar: {
      show: false
    }
  };

  const topMerchantSeries = [
    {
      name: "Orders",
      data: latestTopMerchants.map((val) => val?.orders || 0)
    }
  ];

  return (
    <Row>
      <Col md={12}>
        <Card className="header-cards card overflow-hidden">
          <CardHeader className="d-flex justify-content-between flex-column flex-sm-row">
            <h3 className="mb-0">Top Merchants</h3>
          </CardHeader>
          {isFetching ? (
            <Spinner size="sm" color="primary" className="mx-auto my-5" />
          ) : (
            <BarChart options={topMerchantOptions} series={topMerchantSeries} />
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default TopMerchantsCard;
